import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import httpBaseQuery from "./http-base-query";

export const apiTags = {
  Highlight: "Highlight",
  StreamDetail: "StreamDetail",
  Products: "Products",
  ProductDetail: "ProductDetail",
};

export const apiSlice = createApi({
  reducerPath: "api",
  baseQuery: httpBaseQuery(),
  tagTypes: Object.values(apiTags),
  endpoints: () => ({}),
});
